import _ from "lodash";

import { translate } from "app/filters/i18nFilter";
import { abbrNumberFilter, abbrNumberWithThresholdFilter, yAxisChangeFilter } from "app/filters/ngFilters";
import DurationService from "app/services/DurationService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { VISITS_DATA_THRESHOLD } from "../consts";
import type { YoYResult } from "../types";

export const formatVisits = (value: number) => abbrNumberFilter()(value);

export const formatCategoryName = (category: string): string => {
    if (!category) {
        return translate("analysis.content.lob.autocomplete.placeholder");
    }

    return category.split("~").slice(-1)[0].split(/[$/]/).slice(-1)[0].split("_").map(_.capitalize).join(" ");
};

export const formatVisitsWithThreshold = (value: number) =>
    abbrNumberWithThresholdFilter()({ min: VISITS_DATA_THRESHOLD }, value);

export const calculateChangeFromLastMonth = ({
    currentPeriodVisits,
    comparePeriodVisits,
}: {
    currentPeriodVisits: number | null;
    comparePeriodVisits: number | null;
}) => {
    if (currentPeriodVisits == null || comparePeriodVisits == null || comparePeriodVisits === 0) {
        return null;
    }

    return (currentPeriodVisits - comparePeriodVisits) / comparePeriodVisits;
};

export const getYoYChangeTooltip = () => {
    return translate("analysis.content.lob.yoy.change");
};
export const computeYoY = (current: number, previous: number | null): YoYResult => {
    if (previous === null || current === null) {
        return { label: "-", isDecrease: null, unsigned: true };
    }

    if (previous === 0 && current === 0) {
        return { label: "0", isDecrease: null, unsigned: true };
    }
    const ratio = (current - previous) / previous;
    return {
        label: yAxisChangeFilter()(ratio, 2),
        isDecrease: ratio < 0,
        unsigned: false,
    };
};
